import { useCallback, useState } from "react";
import useHttp from "./useHttp";

function useNumbers(appProperties) {
  const [loading, setLoading] = useState(false);
  const { fetchData } = useHttp();
  const getAllSavedNumbers = async () => {
    try {
      setLoading(true);
      const response = await fetchData(`helloSend/savedNumbers`, "GET", null, appProperties);
      if (response) {
        const responseData = JSON.parse(response);
        return responseData?.data;
      } else {
        throw new Error("Can't able to fetch saved numbers.");
      }
    } catch (e) {
      throw e;
    } finally {
      setLoading(false);
    }
  };

  const getAllBlockedNumbers = useCallback(
    async (asc = false) => {
      try {
        const response = await fetchData(`blockednumbers?asc=${asc}`, "GET", null, appProperties);
        const responseData = JSON.parse(response);
        return responseData?.data;
      } catch (e) {
        throw new Error("Can't able to fetch blocked numbers.");
      }
    },
    [fetchData]
  );

  const unblockNumber = async (toNumber) => {
    try {
      const response = await fetchData(`blockednumber?phoneNumber=${encodeURIComponent(toNumber)}`, "DELETE", null, appProperties);
      const responseData = JSON.parse(response);
      return responseData?.data;
    } catch (e) {
      throw new Error("Can't able to unblock number.");
    }
  };

  const blockNumber = async (toNumber) => {
    try {
      const response = await fetchData(`blockednumber?phoneNumber=${encodeURIComponent(toNumber)}`, "POST", null, appProperties);
      const responseData = JSON.parse(response);
      return responseData?.data;
    } catch (e) {
      throw new Error("Can't able to block number.");
    }
  };
  return {
    loading,
    getAllSavedNumbers,
    blockNumber,
    getAllBlockedNumbers,
    unblockNumber,
  };
}

export default useNumbers;
